/**
 * Highlight slected acordion item when its collapse opened
 */

export default (() => {
  // Check if the parent wrapper has the class 'accordion-decorated'
  const parentWrapper = document.querySelector('.accordion-decorated')
  if (!parentWrapper) {
    return // Exit if the parent wrapper is not found
  }

  document.addEventListener('show.bs.collapse', (event) => {
    if (!event.target.matches('.accordion-collapse')) {
      return
    }

    const item = event.target.closest('.accordion-item')
    item.classList.add('active-panel')
  })

  document.addEventListener('hide.bs.collapse', (event) => {
    if (!event.target.matches('.accordion-collapse')) {
      return false
    }

    const item = event.target.closest('.accordion-item')
    item.classList.remove('active-panel')
  })

  // initialize accordions
  document.querySelectorAll('.accordion-item').forEach((item) => {
    const collapseElement = item.querySelector('.accordion-collapse')

    // Check if the collapse element initially has the 'show' class
    if (collapseElement.classList.contains('show')) {
      item.classList.add('active-panel') // Add your custom class
    }
  })
})()
